import {
  Button as AntdButton,
  Form as FormAntd,
  Row as RowAntd,
  Steps as StepsAntd,
  Typography,
} from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

const { Text } = Typography;

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }

  .margin-sides {
    margin: 0 8px
  }

  .padding-left-37 {
    padding-left: 37px;
  }

  h3.ant-typography {
    font-size: 20px;
    color: #676A6C;
    margin-top: 40px;
  }

  .resize-textarea-none{
    textarea{
      resize: none;
    }
  }
`;

export const RowResumo = styled(RowAntd)`
  flex-direction: column;
  margin-top: 16px;
`;

export const PopOverContentLine = styled(RowAntd)`
  flex-direction: column;
  color: #fff;
`;

export const TitleResumo = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.025em;
  color: #001529;
  margin-bottom: 2px;
`;

export const SubTitleResumo = styled.p`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
`;

export const CountResumo = styled(AntdButton).attrs({
  type: 'link',
})`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 22px;
  color: #24a95d;

  &:hover {
    color: #39c05b;
  }

  &:focus {
    color: #39c05b;
  }
`;

export const TextLink = styled(Text)`
  color: #24a95d;
`;

export const FormItem = styled(FormAntd.Item)`
  flex-direction: row !important;
  position: absolute;
  right: 39px;

  button.ant-switch {
    top: -5px;
    left: 10px;
  }
`;

export const Steps = styled(StepsAntd)`
  padding: 24px 0;

  .ant-steps-item-title,
  .ant-steps-icon {
    font-weight: bold;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    border-bottom: dashed #1890ff;
    border-radius: unset;
    background-color: unset;
  }

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    border: 1px solid rgba(36, 169, 93, 1);
    background-color: rgba(36, 169, 93, 1);
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-icon
    .ant-steps-icon {
    color: #fff !important;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    background-color: #fff;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85) !important;
    margin: 0px 2px;
  }

  .ant-steps .ant-steps-item-finish .ant-steps-icon,
  .ant-steps .ant-steps-item-finish .ant-steps-item-title {
    color: #676a6c !important;
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    background: #4190f7;
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #fff;
  }
`;
